import { ParticipantsSection } from './ContestPage/ParticipantsSection';

export default function ContestUsersPage() {
  return <ParticipantsSection />;
}
